import Collection from "../../data-structures/collection";
import User from "./user";


export default class Users extends Collection<User> {

    constructor(models:User[]=[]) {
        super(models)
    }

    // get(id: ID):User {
    //     return this.byId[id]!
    // }

    resetFromJson(records:JSONArray):void {

        const models : User[] = []
        _.map(records, (record:JSONObject)=>{
            models.push(new User(record))
        })

        this.reset(models)
        // this.sort()
    }

    resetAndKeepOldModels(data:JSONArray):void {
        const previousCollectionModels : User[] = _.clone(this.models)

        this.resetFromJson(data)

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                this.add(model)
            }
        })
    }

    toOptions():Option[] {

        return this.models.map((user:User)=>{
            return {
                value   : user.id,
                label   : user.name
            }
        })

    }
}